import { NavLink, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axios";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import { canAccessApplications } from "../../utils/princetonAccess";
import { useNavigationGuard } from "../../context/NavigationGuard";

const Nav = () => {
  const { authState, setAuthState } = useContext(AuthContext);
  const navigate = useNavigate();
  const { confirmLeave, clearGuard } = useNavigationGuard();
  const [hackathonStatus, setHackathonStatus] = useState("loading");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const canViewApply = canAccessApplications(
    authState.user?.email,
    hackathonStatus
  );

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/applications/cycle/status"
        );
        setHackathonStatus(response.data);
      } catch (error) {
        // console.log(error);
      }
    };

    fetchStatus();
  }, []);

  const handleLogout = async () => {
    if (!confirmLeave()) return;
    try {
      await axiosInstance.post(
        "/api/auth/logout",
        {},
        { withCredentials: true }
      );
      clearGuard();
      setAuthState({ isAuthenticated: false, user: null });
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navigation" aria-label="Primary navigation">
      <div className="left-side">
        <a href="https://www.hackprinceton.com/" className="brand-text-link">
          <span className="brand-route" aria-hidden="true">HP26</span>
          <span className="brand-name">HackPrinceton</span>
          <span className="brand-season">Fall 2026</span>
        </a>
      </div>
      <div className="right-side">
        <button
          type="button"
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation-links"
        >
          ☰
        </button>
        <div
          id="primary-navigation-links"
          className={`nav-links ${isMenuOpen ? "open" : ""}`}
        >
          {authState.isAuthenticated ? (
            <div className="nav-apply-button">
              {authState.isAuthenticated && authState.user.role === "admin" && (
                <NavLink to="/admin" className="nav-link">
                  Admin
                </NavLink>
              )}
              {canViewApply && (
                <NavLink to="/apply" className="nav-link">
                  Apply
                </NavLink>
              )}
              <NavLink to="/dashboard" className="nav-link">
                Dashboard
              </NavLink>
              <button onClick={handleLogout} className="nav-link-but">
                Logout
              </button>
            </div>
          ) : (
            <div className="nav-auth-section">
              <NavLink to="/register" className="nav-link">
                Register
              </NavLink>
              <NavLink to="/login" className="nav-link">
                Login
              </NavLink>
            </div>
          )}
        </div>
        <a
          id="mlh-trust-badge"
          href="https://mlh.io/na?utm_source=na-hackathon&utm_medium=TrustBadge&utm_campaign=2027-season&utm_content=gray"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://s3.amazonaws.com/logged-assets/trust-badge/2027/mlh-trust-badge-2027-white.svg"
            alt="Major League Hacking 2027 Hackathon Season"
            className="mlh-badge"
          />
        </a>
      </div>
    </nav>
  );
};

export default Nav;
